var map = {
	"./cn/mobile/payment/pay_tag.png": "b10b",
	"./en/mobile/payment/pay_tag.png": "07e6",
	"./hk/mobile/payment/pay_tag.png": "81bd",
	"./jp/mobile/payment/pay_tag.png": "da92",
	"./kr/mobile/payment/pay_tag.png": "67b6",
	"./th/mobile/payment/pay_tag.png": "b9a1",
	"./vn/mobile/payment/pay_tag.png": "fc23"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5c8a";